const featureList = [
  {
    id: "1",
    title: "User freiendly",
    img: "feature-tile-icon-01.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
  {
    id: "2",
    title: "User freiendly",
    img: "feature-tile-icon-02.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
  {
    id: "3",
    title: "User freiendly",
    img: "feature-tile-icon-03.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
  {
    id: "4",
    title: "User freiendly",
    img: "feature-tile-icon-04.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
  {
    id: "5",
    title: "User freiendly",
    img: "feature-tile-icon-05.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
  {
    id: "6",
    title: "User freiendly",
    img: "feature-tile-icon-06.svg",
    desc: "A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise design.",
  },
];

export default featureList;
